import React from "react";
import MainContent from "./components/MainContent";

const DefaultLayout = (props) => {
  return (
    <>
      <div className="vds-viewport" id="viewport">
        <MainContent>
          {props.children}
        </MainContent>
      </div>
    </>
  );
};

export default DefaultLayout;
